<template>
    <div>
        <date-picker
            id="datepickerEquipmentRentsPerTimeFrame"
            @apply="onDateChange"
            @loaded="onDatePickerLoaded"
            :mode="'statistics'"
            :presetTimes="getPresetTimes"
            :disabled="false"
        ></date-picker>
        <div class="statsheader">{{ this.$t('statistics.order-count-per-equipment-and-period') }}</div>
        <bryntum-grid
            style="height:100%!important;"
            ref                 = "grid"
            v-bind              = "gridConfig"
        >
        </bryntum-grid>
    </div>
</template>

<script>
import { BryntumGrid } from '@bryntum/schedulerpro-vue';
import RmsObjectsGridColumnImage from '../rmsobjects/rms-objects-grid-column-image.js';
import RmsObjectsGridColumnCurrentStatus from '../rmsobjects/rms-objects-grid-column-current-status.js';
import RmsObjectsGridColumnRequestable from '../rmsobjects/rms-objects-grid-column-requestable.js';

import ObjectLister from "../orders/object-lister.vue";
import RequestsPerTimeFrame from "./RequestsPerTimeFrame.vue";
import zipcelx from "zipcelx";

export default {
    name: "EquipmentRentsPerTimeFrame",
    components:{
        BryntumGrid
    },
    data() {
        return{
            form:{
                from: moment().subtract(1, 'year').startOf('year'),
                until: moment().subtract(1, 'year').endOf('year'),
            },
            availabilityDates:{
                from: moment().subtract(1, 'year').startOf('year'),
                until: moment().subtract(1, 'year').endOf('year'),
            },



            scrollToId: undefined,
            reloadNecessary: false,


            gridDataLoaded: false,
            toolBarHandlersAdded: false,
            displayColumns: [],
            gridConfig:{
            minHeight: '60em',
                baseColumns: [
                { id: 'g-rents-in-date-count', text : this.$t('statistics.orders-per-equipment-per-period-in-orders-in-timeframe'),  type:'number', field : 'rentsInDateCount',           editor : false, width: 250, sortable: true, sum : true},
                { id: 'g-rents-count', text : this.$t('statistics.orders-per-equipment-per-period-in-orders-over-all'),  type:'number', field : 'rentsCount',           editor : false, width: 250, sortable: true, sum : true},
                { id: 'g-image', text : this.$t('objects.grid.image'),                         type  : 'imageColumn',          editor : false, width: 100, filterable: false, sortable: false},
                //{ text : this.$t('objects.grid.category'),                      field : 'categoryName',         editor : false, width: 100, tooltipRenderer: ({ record }) => { if('description' in record.category){ let tr = this.$t('cstrings.' + record.category.description); if(tr != 'cstrings.'){ return tr}else{return record.category.description}}}},
                { id: 'g-category', text : this.$t('objects.grid.category'),                      field : 'categoryName',         editor : false, width: 100},
                { id: 'g-number', text : this.$t('objects.grid.number'),                        field : 'number',               editor : false, width: 150},
                { id: 'g-name', text : this.$t('objects.grid.name'),                          field : 'name',                 editor : false, width: 200},
                { id: 'g-type', text : this.$t('objects.grid.type'),                          field : 'rmsObjectType',        editor : false, width: 200},

                //{ text : this.$t('objects.grid.condition'),                   field : 'condition',            editor : false, width: 250},
                { id: 'g-desc', text : this.$t('objects.grid.description'),                   field : 'desc',                 editor : false, width: 250},
                //{ text : this.$t('objects.grid.inventory-number'),              field : 'inventory_number',     editor : false, width: 150},
                //{ text : this.$t('objects.grid.tags'),                          field : 'tagList',              editor : false, width: 250},
                //{ text : this.$t('objects.grid.location'),                      field : 'locationName',         editor : false, width: 200},
                //{ text : this.$t('objects.grid.current-state'),                 type  : 'currentStatusColumn',                  width: 180},
                //{ text : this.$t('objects.grid.available-for-rent-requests'),   type  : 'requestableColumn',    editor : false, width: 150}
            ],
                columns:[{}],
                actionColumn :
            {
                id: 'g-action',
                type    : 'action',
                    width   : 140,
                text    : '',
                actions : [{
                visible  : AshnetApp.can('equipment read'),
                cls     : 'fad fa-eye',
                tooltip : this.$t('objects.grid.show'),
                onClick : ({ record }) => this.onViewAction(record.id)
            }, /*{
                            visible  : AshnetApp.can('equipment update'),
                            cls     : 'fad fa-edit',
                            tooltip : this.$t('objects.grid.edit'),
                            onClick : ({ record }) => this.onEditAction(record.id)
                        }, {
                            visible  : AshnetApp.can('equipment delete'),
                            cls     : 'fad fa-trash',
                            tooltip : this.$t('objects.grid.delete'),
                            onClick : ({ record }) => this.onDeleteAction(record)
                        },*/ {
                //visible  : ({ record }) => record.requestable === true && AshnetApp.can('orders create'),
                visible  : AshnetApp.can('orders create'),
                cls     : 'fad fa-file-plus',
                tooltip : this.$t('objects.grid.create-order-with-object'),
                onClick : ({ record }) => this.onCreateOrderAction(record.id)
            }]
            },
                store: {
                    syncDataOnLoad: false,
                    useRestfulMethods: true,
                    readUrl: '/api/rmsobjects/customfilter/statistics',
                    deleteUrl: '/api/rmsobjects/delete',
                    pageParamName: 'page',
                    sortParamName: 'sort',
                    filterParamName: 'filter',
                    responseTotalProperty: 'meta.total',
                    pageSize: 25,
                    autoLoad: false,
                    autoCommit: false,
                    useRawData: true,
                    sorters:[
                        { field : 'rentsInDateCount', ascending : false }
                    ],
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                        'X-Requested-With': 'XMLHttpRequest',
                        'X-XSRF-TOKEN': $('meta[name="xsrf-token"]').attr('content')
                    },
                    listeners: {
                        beforeRequest: (e) =>{
                            console.log("beforeRequest");
                            e.params.availabilityFrom = this.availabilityDates.from;
                            e.params.availabilityUntil = this.availabilityDates.until;
                        },
                    },
                },
            selectionMode: {
                row: true,
                    cell: true,
                    rowCheckboxSelection: false,
                    multiSelect: false,
                    checkbox: false,
                    showCheckAll: false
            },

            fixedRowHeight : false,
                listeners: {
                cellDblClick: ({ record }) => {
                    if(AshnetApp.can('equipment read')){
                        this.onViewAction(record.id)
                    }
                }
            },
            tbar : {
                items: [
                    {
                        type      : 'text',
                        ref       : 'filterField',
                        clearable : true,
                        label     : '<i class="b-icon b-icon-search"></i> ' + this.$t('objects.picker.quick-search'),
                        width     : 400,
                        cls       : 'b-bright',
                        //onChange  : ({source: filterField}) => this.onFilterFieldChange(filterField),
                        onInput  : ({source: filterField}) => this.onFilterFieldChange(filterField),
                        onClear   : () => this.onFilterFieldClear()
                    },
                    {
                        type        : 'combo',
                        ref         : 'quickFilter',
                        label       : this.$t('objects.grid.type-filter'),
                        placeholder : this.$t('objects.grid.type-filter-inactive'),
                        width       : 600,
                        editable    : false,
                        multiSelect : false,
                        clearable   : true,
                        items       : [
                            { value : '1', text : 'eBikes' },
                            { value : '2', text : 'Devices' },
                            { value : '3', text : 'MKB Carpool' }
                        ],
                        value : '',
                        onSelect: ({ source : combo, record }) => this.onQuickFilterSelect(combo, record),
                    },
                    /*
                    {
                        type : 'button',
                        color: 'b-blue b-raised',
                        disabled  : !AshnetApp.can('equipment create'),
                        text : this.$t('objects.grid.create'),
                        icon  : 'fa-tbar fad fa-box',
                        onClick: () => this.onClickCreate()
                    },*/
                    /*{
                        type      : 'text',
                        ref       : 'filterField',
                        clearable : true,
                        label     : '<i class="b-icon b-icon-search"></i> ' + this.$t('objects.picker.quick-search'),
                        width     : 400,
                        cls       : 'b-bright',
                        //onChange  : ({source: filterField}) => this.onFilterFieldChange(filterField),
                        onInput  : ({source: filterField}) => this.onFilterFieldChange(filterField),
                        onClear   : () => this.onFilterFieldClear()
                    },
                    {
                        type        : 'combo',
                        ref         : 'quickFilter',
                        label       : this.$t('objects.grid.type-filter'),
                        placeholder : this.$t('objects.grid.type-filter-inactive'),
                        width       : 600,
                        editable    : false,
                        multiSelect : false,
                        clearable   : true,
                        items       : [
                            { value : '1', text : 'eBikes' },
                            { value : '2', text : 'Devices' },
                            { value : '3', text : 'MKB Carpool' }
                        ],
                        value : '',
                        onSelect: ({ source : combo, record }) => this.onQuickFilterSelect(combo, record),
                    },
                    {
                        type : 'slidetoggle',
                        ref  : 'includeArchiveSlider',
                        text : this.$t('objects.grid.include-archive'),
                        listeners: {
                            change: this.onChangeArchiveFlag
                        }
                    },*/
                    /*
                    {
                        text : this.$t('objects.grid.type-filter-remove'),
                        icon  : 'fa-tbar fad fa-filter',
                        onClick: () => {
                            this.$refs.grid.gridInstance.widgetMap.includeArchiveSlider.checked = false; // Nicht mehr im Archiv suchen
                            this.$refs.grid.gridInstance.widgetMap.quickFilter.value = null; //schnellfilter combo leeren
                            this.$refs.grid.gridInstance.store.clearFilters();
                        }
                    },
                    {
                        type: 'button',
                        text : this.$t('objects.grid.sort-reset'),
                        icon  : 'fa-tbar fad fa-sort-alt',
                        onClick: () => {
                            this.$refs.grid.gridInstance.store.clearSorters();
                        }
                    },
                    {
                        type: 'button',
                        ref: 'clearButton',
                        text : this.$t('objects.grid.column-config-reset'),
                        icon  : 'fa-tbar fad fa-columns',
                        disabled : !localStorage.getItem('ashrms-rms-objects-grid-state'),
                        onClick: () => {
                            this.resetGridState();
                            this.$refs.grid.gridInstance.widgetMap.clearButton.disable();
                        }
                    },*/
                    {
                        type : 'button',
                        ref  : 'exportExcelButton',
                        icon : 'fad fa-file-excel',
                        text : this.$t('objects.grid.excel-export'),
                        listeners: {
                            click: this.onExportExcelClick
                        }
                    },
                    {
                        type : 'button',
                        ref  : 'exportButton',
                        icon : 'fad fa-file-export',
                        text : this.$t('objects.grid.pdf-png-export'),
                        listeners: {
                            click: this.onExportClick
                        }
                    }
                ]
            },
            bbar : {
                type : 'pagingtoolbar'
            },
            summaryFeature:false,
            headerMenuFeature: true,
            cellTooltipFeature: true,
            filterBarFeature : false,
            pdfExportFeature: {
                exportServer: 'https://exportdata.ashnet.cloud:8081',
            },
            excelExporterFeature : {
                zipcelx
            },
            rowCopyPasteFeature : false,
                cellMenuFeature : {
                items : {
                    removeRow: false,
                        customDisplay: {
                        disabled  : !AshnetApp.can('equipment read'),
                            text : this.$t('objects.grid.show'),
                            icon: 'fad fa-eye',
                            onItem : ({ record }) => this.onViewAction(record.id)
                    },/*
                        customEdit: {
                            disabled  : !AshnetApp.can('equipment update'),
                            text : this.$t('objects.grid.edit'),
                            icon: 'fad fa-edit',
                            onItem : ({ record }) => this.onEditAction(record.id)
                        },
                        customDelete: {
                            disabled  : !AshnetApp.can('equipment delete'),
                            text : this.$t('objects.grid.delete'),
                            icon: 'fad fa-trash',
                            onItem : ({ record }) => this.onDeleteAction(record.id)
                        },*/
                    customStartOrder: {
                        disabled  : !AshnetApp.can('orders create'),
                            text : this.$t('objects.grid.create-order-with-object'),
                            icon: 'fa-cellmenu fad fa-file-plus',
                            onItem : ({ record }) => this.onCreateOrderAction(record.id)
                    },
                }
            }
        },
        }
    },
    computed: {
        getPresetTimes(){
            console.log("form-order: getPresetTimes", {from: this.form.from, until: this.form.until});
            if(this.presetdata != undefined && this.presetdata !== false && this.presetdata.hasOwnProperty("startDate") && this.presetdata.hasOwnProperty("endDate")){
                return {
                    from: moment.parseZone(this.presetdata.startDate),
                    until: moment.parseZone(this.presetdata.endDate),
                };
            }else{
                console.log("retuning safe last year");
                return {from: this.form.from, until: this.form.until};
            }
        },


        getData() {
            return this.gridData.map((item) =>
                Object.assign({ inEdit: item.ProductID === this.editID }, item)
            );
        },
        result: {
            get: function () {
                return process(this.gridData, {
                    sort: this.sort,
                    filter: this.filter,
                    take: this.take,
                    skip: this.skip,
                });
            },
        },
    },
    mounted(){
        this.init();
    },
    methods:{
        init: function () {

            // Alle Felder laden und zu gridComumns (der Spaltendefinition) hinzufügen
            // Erst felder vorausladen, dann store laden
            this.preloadFields().then(()=>{
                this.$refs.grid.gridInstance.columns.autoAddField = true;
                this.$refs.grid.gridInstance.store.load().then(() =>{
                    this.loadFields();
                });

            });
        },

        leaving: function () {
            //this.saveGridState('ashrms-rms-objects-grid-state');
        },

        onFilterFieldChange: _.debounce(function (e) {
            this.performAllColumnFilter(e.value);
        }, 500),

        performAllColumnFilter: function(filterValue){
            // Serverseitige Lösung. Ein spezieller Name "allColumnsFilter" um eine Sonderbehandlung, bzw. die serverseitige suche nach dem Eintrag zu starten
            this.$refs.grid.gridInstance.store.filter({
                id: 'special_search',
                filters: {
                    property: 'special_search',
                    operator: '*',
                    value: filterValue
                },
                replace : false
            });
        },

        onFilterFieldClear: function(){
            console.log("onFilterFieldClear");
            this.$refs.grid.gridInstance.store.removeFilter('special_search');
        },

        preloadFields: async function(fieldsId = null){
            console.log("preloadFields: erst fields preload");
            if (fieldsId != null) {
                console.log("preloadFields: lade einzelne Definition");
                return axios.get('/api/rmsobjects/fieldsdefinitions/id/' + fieldsId)
                    .then(response => {
                        this.preloadedFields = response.data.field_type;
                    });
            }else{
                console.log("preloadFields: lade alle felder");
                return axios.get('/api/rmsobjects/fields')
                    .then(response => {
                        this.preloadedFields = response.data;
                    });
            }
        },

        // region Dynamische Spalten
        loadFields: function (fieldsId = null) {
            if (fieldsId != null) {
                console.log("loadFields: einzelne Definition");
                this.addFields(this.preloadedFields);
            } else {
                console.log("loadFields: preloaded fields zuweisen");
                this.addFields(this.preloadedFields);
            }
            this.initStates();
        },

        addFields: function (customFields) {
            // Alle Spalten entfernen
            this.$refs.grid.gridInstance.columns.removeAll();

            // Basis-Spalten hinzufügen
            this.$refs.grid.gridInstance.columns.add(this.gridConfig.baseColumns)


            let that = this;
            customFields.map(function (value, key) {
                if (value.configuration.model != 'name' && value.configuration.model != 'desc') {

                    let tmpObj = {
                        text: that.$t("cstrings.colfields."+value.configuration.label),
                        field: 'form_data.' + value.configuration.model,
                        editor: false
                    };
                    that.$refs.grid.gridInstance.columns.add(JSON.parse(JSON.stringify(tmpObj)));

                }
            });

            // Als letztes die Action-Spalten hinzufügen
            this.$refs.grid.gridInstance.columns.add(this.gridConfig.actionColumn);
            this.$refs.grid.gridInstance.columns.commit();
        },

        /**
         * Fügt Funktionalität für States des Grids hinzu
         */
        initStates: function () {
            console.log("initstates geladen");
            //this.saveGridState('ashrms-rms-objects-grid-state-default');

            // Falls eine Gridkonfiguration vorhanden ist, diese laden
            //this.loadGridState('ashrms-rms-objects-grid-state');

            // Listener für Gridstate hinzufügen
            this.$refs.grid.gridInstance.columns.on({
                change: _.debounce(({action, records: columns}) => {
                    //this.saveGridState('ashrms-rms-objects-grid-state');
                    // Wenn nicht der default state gesichert wird, den zurücksetzen button deaktiviert
                    this.$refs.grid.gridInstance.widgetMap.clearButton.enable();
                },500)
            });
        },

        onQuickFilterSelect: function (combo, record) {
            // Wenn Alle Elemente des Filters entfernt wurden, Filter zurücksetzen und verlassen
            if (record == undefined) {
                this.$refs.grid.gridInstance.store.removeFilter('field_set_definition_id_filter');
                return;
            }

            if (combo.selecting) {
                return;
            }

            if (record) {
                // Spezifische Spalten laden
                // Todo: Wenn mehrere Einträge gewählt wurden, eigentlich nicht alle Spalten laden sondern nur die der benötigten
                // Todo: Fehler - Aktuell und durch den State würden die Inhalte neu geladen werden
                /*if(record.length == 1){
                    this.loadFields(record[0].value);
                }else{
                    this.loadFields();
                }*/
                this.$refs.grid.gridInstance.store.removeFilter('field_set_definition_id_filter');
                this.$refs.grid.gridInstance.store.filter(
                    {
                        filters: {
                            id: 'field_set_definition_id_filter',
                            property: 'field_set_definition_id',
                            operator: '=',
                            value: record.value
                        },
                        replace: false
                    }
                );

                combo.selecting = false;
            } else {
                // Alle Felder wieder herstellen
                //this.loadFields();
                //this.onFilterReset();
                this.$refs.grid.gridInstance.store.removeFilter('field_set_definition_id_filter');
                this.$refs.grid.gridInstance.widgetMap.quickFilter.value = null; //schnellfilter combo leeren
            }
        },


        onCreateOrderAction: function (id) {
            console.log("create Order action", id);
            //location.href = "/orders/create/o/" + id;
            this.$router.push({ name: 'order-create', params:
                    {
                        rmsobjectid: id,
                        mode: 'create'
                    } });
        },
        onViewAction: function (id) {
            console.log("view action", id);
            //location.href = "/objects#/objects-details/" + id;
            this.$router.push({ name: 'objects-details', params:
                    {
                        rmsobjectid: id,
                        mode: 'display'
                    } });
        },

        itemChange: function (e) {
            const data = this.gridData.slice();
            const index = data.findIndex((d) => d.ProductID === e.dataItem.ProductID);
            data[index] = { ...data[index], [e.field]: e.value };
            this.gridData = data;
            if (event.dataItem) {
                event.dataItem[e.field] = e.value;
            }
        },
        rowClick: function (e) {
            this.gridData.map((item) => (item.inEdit = false));
            this.editID = e.dataItem.ProductID;
            e.dataItem.inEdit = true;
        },
        closeEdit(e) {
            if (e.target === e.currentTarget) {
                this.editID = null;
            }
        },
        addRecord() {
            const newRecord = { ProductID: this.gridData.length + 1 };
            const data = this.gridData.slice();
            data.unshift(newRecord);
            this.gridData = data;
            this.editID = newRecord.ProductID;
        },
        sortChangeHandler(event) {
            this.sort = event.sort;
        },
        filterChangeHandler(event) {
            this.filter = event.filter;
        },
        pageChangeHandler(event) {
            this.take = event.page.take;
            this.skip = event.page.skip;
        },

        onMenuSelect(event){
            console.log(event);
            this.activeChart = event.item.value;
        },



        onHorizontalChange(event) {
            this.horizontalPanes = event.newState;
        },
        onVerticalChange(event) {
            this.verticalPanes = event.newState;
        },

        onExportExcelClick: function onExportExcelClick() {
            this.$refs.grid.gridInstance.features.excelExporter["export"]({
                filename: 'RM-Export-Orders',
                dateFormat: AshnetApp.dateTimeFormat,
                exporterConfig: {
                    // Todo: Automatische Konfiguration verwenden, da die Gruppierungen durch die explizite Angabe von columns verschwinden
                    // Bug:
                    //columns      : this.schedulerConfig.columns,
                    /*eventColumns : [
                        { text: 'Auftrag', field: 'name', width: 300},
                        { text: 'Beginn', field: 'startDate', width: 300},
                        { text: 'Ende', field: 'endDate', width: 300},
                    ]*/
                }
            });
        },
        onExportClick: function onExportClick() {
            this.$refs.grid.gridInstance.features.pdfExport.showExportDialog();
        },


        onDatePickerLoaded: function (dates) {
            /*
            console.log("Picker loaded with dates", dates);
            this.form.dates = dates;
            this.form.from = dates.from;
            this.form.until = dates.until;
            */
        },

        onDateChange: function (dates) {
            console.log("Zeitraum geändert", dates);
            this.form.dates = dates;
            this.form.from = dates.from;
            this.form.until = dates.until;

            this.availabilityDates.from = dates.from;
            this.availabilityDates.until = dates.until;

            console.log("Lade Statistik neu");
            // Nur den Object Picker neu laden, wenn auch direkt equipment gewählt werden soll
            //this.$refs.grid.reloadStore();
            //this.$refs.grid.gridInstance.store.reloadStore()
            this.$refs.grid.gridInstance.store.load();

        },
    }
}
</script>

<style scoped>
.statsheader{
    text-align:center;
    padding-top:15px;
    padding-bottom:15px;
    font-size:1.15em;
}
</style>
